import React from 'react';
import { Mail, Book, Wrench, MessageCircle, Clock, CheckCircle } from 'lucide-react';

const Support = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-blue-600 border-b-2 border-blue-600 pb-4 mb-6">
            Athena Support
          </h1>
          
          <p className="text-lg text-gray-700 mb-8">
            Welcome to Athena Support! We're here to help you get the most out of your Athena experience. Choose from the support options below.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {/* Email Support */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <div className="flex items-center mb-4">
                <Mail className="w-6 h-6 text-blue-600 mr-3" />
                <h3 className="text-xl font-semibold text-blue-800">Email Support</h3>
              </div>
              <p className="text-gray-700 mb-4">
                Get direct support from our team via email. We typically respond within 24 hours during business days.
              </p>
              <div className="bg-white rounded-lg p-4 mb-4">
                <p className="font-semibold">Email: <a href="mailto:support@rclintegrated.com" className="text-blue-600 hover:underline">support@rclintegrated.com</a></p>
              </div>
              <p className="text-sm text-gray-600 italic">
                Please include your account email and a detailed description of your issue.
              </p>
            </div>

            {/* Documentation */}
            <div className="bg-green-50 border border-green-200 rounded-lg p-6">
              <div className="flex items-center mb-4">
                <Book className="w-6 h-6 text-green-600 mr-3" />
                <h3 className="text-xl font-semibold text-green-800">Documentation</h3>
              </div>
              <p className="text-gray-700 mb-4">
                Browse our comprehensive guides and tutorials:
              </p>
              <ul className="space-y-2">
                <li>
                  <a href="/zoom-documentation" className="text-blue-600 hover:underline flex items-center">
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Zoom Integration Guide
                  </a>
                </li>
                <li className="text-gray-500 flex items-center">
                  <Clock className="w-4 h-4 mr-2" />
                  Getting Started Guide (Coming Soon)
                </li>
                <li className="text-gray-500 flex items-center">
                  <Clock className="w-4 h-4 mr-2" />
                  API Documentation (Coming Soon)
                </li>
              </ul>
            </div>
          </div>

          {/* Technical Issues */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
            <div className="flex items-center mb-4">
              <Wrench className="w-6 h-6 text-yellow-600 mr-3" />
              <h3 className="text-xl font-semibold text-yellow-800">Technical Issues</h3>
            </div>
            <p className="text-gray-700 mb-4">
              Experiencing technical difficulties? Try these steps:
            </p>
            <ol className="list-decimal pl-6 space-y-2 mb-4">
              <li>Clear your browser cache and cookies</li>
              <li>Try using an incognito/private browser window</li>
              <li>Check if you're using a supported browser (Chrome, Firefox, Safari, Edge)</li>
              <li>Verify your internet connection</li>
            </ol>
            <p className="text-gray-700 mb-2">If issues persist, email us with:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Screenshot of any error messages</li>
              <li>Steps to reproduce the issue</li>
            </ul>
          </div>

          {/* Feature Requests */}
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-6 mb-6">
            <div className="flex items-center mb-4">
              <MessageCircle className="w-6 h-6 text-purple-600 mr-3" />
              <h3 className="text-xl font-semibold text-purple-800">Feature Requests & Feedback</h3>
            </div>
            <p className="text-gray-700 mb-4">
              Have an idea for improving Athena? We'd love to hear from you!
            </p>
            <p className="text-gray-700">
              Send your suggestions and feedback to: <a href="mailto:support@rclintegrated.com" className="text-blue-600 hover:underline">support@rclintegrated.com</a>
            </p>
          </div>

          {/* Status */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">System Status</h3>
            <div className="flex items-center">
              <div className="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
              <span className="text-gray-700">All systems operational</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;